<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      title="自定义交期批量提交"
      width="500px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="param"
        class="form"
        label-width="80px">
      <el-row>
        <el-col>
          <el-form-item prop="responseTime" label="交期" :rules="$rule.notNull">
            <el-date-picker
                v-model="param.responseTime"
                type="date"
                style="width: 100%"
                placeholder="请选择交期"
                value-format="yyyy-MM-dd 00:00:00"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        dialogVisible: false,
        param: {
          orderVoList: [],
          responseTime: "",
        },
      };
    },
    methods: {
      open(list) {
        this.dialogVisible = true;
        this.param.orderVoList = list;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if(valid) {
            this.$http.post("basic", "sAPPurchaseOrders/responseDeliveryTimeList",this.param).then((res) => {
              this.$emit("save-success");
              this.dialogVisible = false;
              this.$message.success("提交成功");
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
